import type {
  MeResponse, LoginRequest, ActivateRequest, ResetRequest, ResetConfirm,
} from '@swiftpay/shared';
import { apiFetch } from '../api/client.js';

export const authApi = {
  me: () => apiFetch<MeResponse>('/api/auth/me'),
  login: (body: LoginRequest) =>
    apiFetch<{ ok: true }>('/api/auth/login', { method: 'POST', body: JSON.stringify(body) }),
  logout: () => apiFetch<{ ok: true }>('/api/auth/logout', { method: 'POST' }),
  activate: (body: ActivateRequest) =>
    apiFetch<{ ok: true }>('/api/auth/activate', { method: 'POST', body: JSON.stringify(body) }),
  resetRequest: (body: ResetRequest) =>
    apiFetch<{ ok: true }>('/api/auth/reset-password/request', {
      method: 'POST', body: JSON.stringify(body),
    }),
  resetConfirm: (body: ResetConfirm) =>
    apiFetch<{ ok: true }>('/api/auth/reset-password/confirm', {
      method: 'POST', body: JSON.stringify(body),
    }),
  verifyEmailRequest: () =>
    apiFetch<{ ok: true }>('/api/auth/verify-email/request', { method: 'POST' }),
  verifyEmailConfirm: (code: string) =>
    apiFetch<{ ok: true }>('/api/auth/verify-email/confirm', {
      method: 'POST', body: JSON.stringify({ code }),
    }),
};
